module.exports = __webpack_public_path__ + "img/mob1.b1073696.png";